"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLatestGovPricing = void 0;
var prisma_1 = require("@ambler/prisma");
var lodash_1 = require("lodash");
var zod_1 = require("zod");
var schema = zod_1.z.array(zod_1.z.object({
    id: zod_1.z.nativeEnum(prisma_1.$Enums.GovPriceInfoFunction),
    startDate: zod_1.z.date(),
    vehiclePricingType: zod_1.z.nativeEnum(prisma_1.$Enums.VehiclePricingType),
    type: zod_1.z.nativeEnum(prisma_1.$Enums.MedicalTransporterGovPricingType),
    pricePerKm: zod_1.z.number().int(),
    nightRate: zod_1.z.number().nonnegative(),
    sundayRate: zod_1.z.number().nonnegative(),
    incubatorExtra: zod_1.z.number().int(),
    airportStationPortExtra: zod_1.z.number().int(),
    pooling2DiscountRate: zod_1.z.number().nonnegative().nullable(),
    pooling3DiscountRate: zod_1.z.number().nonnegative().nullable(),
    flatFees: zod_1.z
        .array(zod_1.z.object({
        type: zod_1.z.nativeEnum(prisma_1.$Enums.FlatFeeType),
        price: zod_1.z.number().int(),
    }))
        .nonempty(),
    shortTripFeeTiers: zod_1.z
        .array(zod_1.z.object({
        price: zod_1.z.number().int(),
        distance: zod_1.z.number().int(),
    }))
        .nonempty(),
}));
var pricings = schema.parse([
    {
        id: 'GOV_CPAM_AMBULANCE_2020_06_11',
        airportStationPortExtra: 2167,
        flatFees: [
            {
                price: 6430,
                type: 'PRISE_EN_CHARGE',
            },
            {
                price: 5130,
                type: 'DEPARTEMENTAL',
            },
            {
                price: 5737,
                type: 'AGGLOMERATION',
            },
        ],
        incubatorExtra: 1083,
        nightRate: 0.75,
        pooling2DiscountRate: null,
        pooling3DiscountRate: null,
        pricePerKm: 219,
        shortTripFeeTiers: [
            {
                distance: 5,
                price: 700,
            },
            {
                distance: 10,
                price: 550,
            },
            {
                distance: 15,
                price: 400,
            },
            {
                distance: 19,
                price: 250,
            },
        ],
        startDate: new Date('2020-06-11T20:22:51.857Z'),
        sundayRate: 0.5,
        type: 'CPAM',
        vehiclePricingType: 'AMBULANCE',
    },
    {
        id: 'GOV_CPAM_TAP_2020_06_11',
        airportStationPortExtra: 1907,
        flatFees: [
            {
                price: 1558,
                type: 'PRISE_EN_CHARGE',
            },
            {
                price: 1385,
                type: 'A',
            },
            {
                price: 1345,
                type: 'B',
            },
            {
                price: 1260,
                type: 'C',
            },
            {
                price: 1197,
                type: 'D',
            },
        ],
        incubatorExtra: 0,
        nightRate: 0.75,
        pooling2DiscountRate: 0.15,
        pooling3DiscountRate: 0.33,
        pricePerKm: 89,
        shortTripFeeTiers: [
            {
                distance: 18,
                price: 83,
            },
            {
                distance: 17,
                price: 136,
            },
            {
                distance: 16,
                price: 188,
            },
            {
                distance: 15,
                price: 240,
            },
            {
                distance: 14,
                price: 292,
            },
            {
                distance: 13,
                price: 344,
            },
            {
                distance: 12,
                price: 396,
            },
            {
                distance: 11,
                price: 448,
            },
            {
                distance: 10,
                price: 500,
            },
            {
                distance: 9,
                price: 553,
            },
            {
                distance: 8,
                price: 605,
            },
            {
                distance: 7,
                price: 626,
            },
        ],
        startDate: new Date('2020-06-11T20:22:52.015Z'),
        sundayRate: 0.5,
        type: 'CPAM',
        vehiclePricingType: 'TAP',
    },
    {
        id: 'GOV_CPAM_AMBULANCE_2021_03_15',
        airportStationPortExtra: 2167,
        flatFees: [
            {
                price: 6505,
                type: 'PRISE_EN_CHARGE',
            },
            {
                price: 5205,
                type: 'DEPARTEMENTAL',
            },
            {
                price: 5812,
                type: 'AGGLOMERATION',
            },
        ],
        incubatorExtra: 1083,
        nightRate: 0.75,
        pooling2DiscountRate: null,
        pooling3DiscountRate: null,
        pricePerKm: 232,
        shortTripFeeTiers: [
            {
                distance: 5,
                price: 791,
            },
            {
                distance: 10,
                price: 622,
            },
            {
                distance: 15,
                price: 452,
            },
            {
                distance: 19,
                price: 283,
            },
        ],
        startDate: new Date('2021-03-15T15:50:24.936Z'),
        sundayRate: 0.5,
        type: 'CPAM',
        vehiclePricingType: 'AMBULANCE',
    },
    {
        id: 'GOV_CPAM_TAP_2021_03_15',
        airportStationPortExtra: 1907,
        flatFees: [
            {
                price: 1558,
                type: 'PRISE_EN_CHARGE',
            },
            {
                price: 1385,
                type: 'A',
            },
            {
                price: 1345,
                type: 'B',
            },
            {
                price: 1260,
                type: 'C',
            },
            {
                price: 1197,
                type: 'D',
            },
        ],
        incubatorExtra: 0,
        nightRate: 0.75,
        pooling2DiscountRate: 0.23,
        pooling3DiscountRate: 0.35,
        pricePerKm: 89,
        shortTripFeeTiers: [
            {
                distance: 18,
                price: 87,
            },
            {
                distance: 17,
                price: 143,
            },
            {
                distance: 16,
                price: 197,
            },
            {
                distance: 15,
                price: 252,
            },
            {
                distance: 14,
                price: 307,
            },
            {
                distance: 13,
                price: 361,
            },
            {
                distance: 12,
                price: 416,
            },
            {
                distance: 11,
                price: 470,
            },
            {
                distance: 10,
                price: 525,
            },
            {
                distance: 9,
                price: 581,
            },
            {
                distance: 8,
                price: 635,
            },
            {
                distance: 7,
                price: 657,
            },
        ],
        startDate: new Date('2021-03-15T15:50:25.050Z'),
        sundayRate: 0.5,
        type: 'CPAM',
        vehiclePricingType: 'TAP',
    },
    // * 7 novembre 2023
    // * New CPAM pricing update
    {
        id: 'GOV_CPAM_AMBULANCE_2023_11_07',
        airportStationPortExtra: 2167,
        flatFees: [
            {
                price: 6551,
                type: 'PRISE_EN_CHARGE',
            },
            {
                price: 5241,
                type: 'DEPARTEMENTAL',
            },
            {
                price: 5853,
                type: 'AGGLOMERATION',
            },
        ],
        incubatorExtra: 1083,
        nightRate: 0.75,
        pooling2DiscountRate: null,
        pooling3DiscountRate: null,
        pricePerKm: 244,
        shortTripFeeTiers: [
            {
                distance: 5,
                price: 870,
            },
            {
                distance: 10,
                price: 684,
            },
            {
                distance: 15,
                price: 497,
            },
            {
                distance: 19,
                price: 311,
            },
        ],
        startDate: new Date('2023-11-06T23:00:00.000Z'),
        sundayRate: 0.5,
        type: 'CPAM',
        vehiclePricingType: 'AMBULANCE',
    },
    {
        id: 'GOV_CPAM_TAP_2023_11_07',
        airportStationPortExtra: 1907,
        flatFees: [
            {
                price: 1416,
                type: 'PRISE_EN_CHARGE',
            },
            {
                price: 1303,
                type: 'A',
            },
            {
                price: 1265,
                type: 'B',
            },
            {
                price: 1185,
                type: 'C',
            },
            {
                price: 1121,
                type: 'D',
            },
        ],
        incubatorExtra: 0,
        nightRate: 0.5,
        pooling2DiscountRate: 0.23,
        pooling3DiscountRate: 0.35,
        pricePerKm: 97,
        shortTripFeeTiers: [
            {
                distance: 18,
                price: 83,
            },
            {
                distance: 17,
                price: 136,
            },
            {
                distance: 16,
                price: 188,
            },
            {
                distance: 15,
                price: 255,
            },
            {
                distance: 14,
                price: 310,
            },
            {
                distance: 13,
                price: 365,
            },
            {
                distance: 12,
                price: 420,
            },
            {
                distance: 11,
                price: 475,
            },
            {
                distance: 10,
                price: 577,
            },
            {
                distance: 9,
                price: 639,
            },
            {
                distance: 8,
                price: 698,
            },
            {
                distance: 7,
                price: 776,
            },
        ],
        startDate: new Date('2023-11-06T23:00:00.000Z'),
        sundayRate: 0.25,
        type: 'CPAM',
        vehiclePricingType: 'TAP',
    },
    // * 6 mai 2024
    // * CPAM SEFi & Geoloc
    {
        id: 'GOV_CPAM_SEFI_GEO_AMBULANCE_2024_05_06',
        airportStationPortExtra: 2167,
        flatFees: [
            {
                price: 6830,
                type: 'PRISE_EN_CHARGE',
            },
            {
                price: 5465,
                type: 'DEPARTEMENTAL',
            },
            {
                price: 6103,
                type: 'AGGLOMERATION',
            },
        ],
        incubatorExtra: 1083,
        nightRate: 0.75,
        pooling2DiscountRate: null,
        pooling3DiscountRate: null,
        pricePerKm: 244,
        shortTripFeeTiers: [
            {
                distance: 5,
                price: 870,
            },
            {
                distance: 10,
                price: 684,
            },
            {
                distance: 15,
                price: 497,
            },
            {
                distance: 19,
                price: 311,
            },
        ],
        startDate: new Date('2024-05-05T22:00:00.000Z'),
        sundayRate: 0.5,
        type: 'CPAM_SEFI_GEO',
        vehiclePricingType: 'AMBULANCE',
    },
    {
        id: 'GOV_CPAM_SEFI_GEO_TAP_2024_05_06',
        airportStationPortExtra: 1907,
        flatFees: [
            {
                price: 1455,
                type: 'PRISE_EN_CHARGE',
            },
            {
                price: 1364,
                type: 'A',
            },
            {
                price: 1364,
                type: 'B',
            },
            {
                price: 1364,
                type: 'C',
            },
            {
                price: 1364,
                type: 'D',
            },
        ],
        incubatorExtra: 0,
        nightRate: 0.5,
        pooling2DiscountRate: 0.15,
        pooling3DiscountRate: 0.33,
        pricePerKm: 97,
        shortTripFeeTiers: [
            {
                distance: 18,
                price: 83,
            },
            {
                distance: 17,
                price: 136,
            },
            {
                distance: 16,
                price: 188,
            },
            {
                distance: 15,
                price: 255,
            },
            {
                distance: 14,
                price: 310,
            },
            {
                distance: 13,
                price: 365,
            },
            {
                distance: 12,
                price: 420,
            },
            {
                distance: 11,
                price: 475,
            },
            {
                distance: 10,
                price: 577,
            },
            {
                distance: 9,
                price: 639,
            },
            {
                distance: 8,
                price: 698,
            },
            {
                distance: 7,
                price: 776,
            },
        ],
        startDate: new Date('2024-05-05T22:00:00.000Z'),
        sundayRate: 0.25,
        type: 'CPAM_SEFI_GEO',
        vehiclePricingType: 'TAP',
    },
    {
        id: 'GOV_CPAM_SEFI_GEO_AMBULANCE_2025_01_01',
        airportStationPortExtra: 2167,
        flatFees: [
            {
                price: 7172,
                type: 'PRISE_EN_CHARGE',
            },
            {
                price: 5739,
                type: 'DEPARTEMENTAL',
            },
            {
                price: 6408,
                type: 'AGGLOMERATION',
            },
        ],
        incubatorExtra: 1083,
        nightRate: 0.75,
        pooling2DiscountRate: null,
        pooling3DiscountRate: null,
        pricePerKm: 244,
        shortTripFeeTiers: [
            {
                distance: 5,
                price: 975,
            },
            {
                distance: 10,
                price: 753,
            },
            {
                distance: 15,
                price: 547,
            },
            {
                distance: 19,
                price: 342,
            },
        ],
        startDate: new Date('2024-12-31T23:00:00.000Z'),
        sundayRate: 0.5,
        type: 'CPAM_SEFI_GEO',
        vehiclePricingType: 'AMBULANCE',
    },
    {
        id: 'GOV_CPAM_SEFI_GEO_TAP_2025_01_01',
        airportStationPortExtra: 1907,
        flatFees: [
            {
                price: 1527,
                type: 'PRISE_EN_CHARGE',
            },
            {
                price: 1432,
                type: 'A',
            },
            {
                price: 1432,
                type: 'B',
            },
            {
                price: 1432,
                type: 'C',
            },
            {
                price: 1432,
                type: 'D',
            },
        ],
        incubatorExtra: 0,
        nightRate: 0.5,
        pooling2DiscountRate: 0.15,
        pooling3DiscountRate: 0.33,
        pricePerKm: 100,
        shortTripFeeTiers: [
            {
                distance: 18,
                price: 83,
            },
            {
                distance: 17,
                price: 136,
            },
            {
                distance: 16,
                price: 188,
            },
            {
                distance: 15,
                price: 255,
            },
            {
                distance: 14,
                price: 310,
            },
            {
                distance: 13,
                price: 365,
            },
            {
                distance: 12,
                price: 420,
            },
            {
                distance: 11,
                price: 475,
            },
            {
                distance: 10,
                price: 577,
            },
            {
                distance: 9,
                price: 639,
            },
            {
                distance: 8,
                price: 698,
            },
            {
                distance: 7,
                price: 776,
            },
        ],
        startDate: new Date('2024-05-05T22:00:00.000Z'),
        sundayRate: 0.25,
        type: 'CPAM_SEFI_GEO',
        vehiclePricingType: 'TAP',
    },
]);
var sortedPricings = (0, lodash_1.sortBy)(pricings, function (p) { return p.startDate; });
var getFilteredPricings = function (selector) { return sortedPricings.filter(selector); };
var getLatestGovPricing = function (vehiclePricingType, departureTime, mtPricingType) {
    var _a;
    var pricings = getFilteredPricings(function (pricing) { return pricing.vehiclePricingType === vehiclePricingType; });
    var pricingType = departureTime >= new Date('2024-05-05T22:00:00.000Z') ? mtPricingType : 'CPAM';
    return ((_a = pricings.findLast(function (pricing) { return pricing.startDate <= departureTime && pricing.type === pricingType; })) !== null && _a !== void 0 ? _a : 
    // * Fallback to the latest CPAM pricing if no pricing found
    pricings.findLast(function (pricing) { return pricing.type === 'CPAM'; }));
};
exports.getLatestGovPricing = getLatestGovPricing;
//# sourceMappingURL=gov-pricing.js.map